import { useMutation } from '@tanstack/react-query';
import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { companyService } from 'services';
import { useForm } from 'react-hook-form';

const Tarea = () => {
 /* const { data } = useQuery({
    queryKey: ['company'],
    queryFn: () => companyService.consultCompanyByNit('901600406')
  }); */

 //const {mutate} = useMutation(companyService.registerCompany)

 const newCompany = useMutation({
  mutationFn: companyService.registerCompany
 });

 const { register, handleSubmit } = useForm();

 const send = datos => {
  newCompany.mutate(datos);
  //mutate(datos)
  console.log(datos);
 };

 return (
  <div>
   <Form className="container" onSubmit={handleSubmit(send)}>
    <Form.Group>
     <Form.Group>
      <Form.Label>Fullname</Form.Label>
      <Form.Control type="text" {...register('fullname')} />
     </Form.Group>
     <Form.Group>
      <Form.Label>Email</Form.Label>
      <Form.Control type="text" {...register('email')} />
     </Form.Group>
     <Form.Group>
      <Form.Label>password</Form.Label>
      <Form.Control type="password" {...register('password')} />
     </Form.Group>
     <Form.Group>
      <Form.Label>name</Form.Label>
      <Form.Control type="text" {...register('name')} />
     </Form.Group>
     <Form.Group>
      <Form.Label>nit</Form.Label>
      <Form.Control type="text" {...register('nit')} />
     </Form.Group>
     <Form.Group>
      <Form.Label>Telefono</Form.Label>
      <Form.Control type="text" {...register('phone')} />
     </Form.Group>
     <Form.Group>
      <Form.Label>City</Form.Label>
      <Form.Control type="text" {...register('city')} />
     </Form.Group>
    </Form.Group>
    <Form.Group className="mt-3">
     <Button type="submit">Send</Button>
     {/* <Button onClick={() => console.log('data', data)}>Show me</Button> */}
    </Form.Group>
   </Form>
  </div>
 );
};

export default Tarea;
